import { useAuthQuery, UseQueryExtendedOptions } from "@bn/api";
import { loadDividends, DividendsParams } from "@api/v1/methods";
import { DividendList } from "@api/v1/model";
import { DIVIDENDS } from "../../cacheKeys";

export const useDividends = (
  params: DividendsParams,
  options?: UseQueryExtendedOptions<DividendList, AxiosApiError, DividendList>
) => {
  return useAuthQuery<DividendList, AxiosApiError, DividendList>(
    [DIVIDENDS, params],

    ({ token }) => loadDividends(token, params),
    options
  );
};
